(ns global.endor.checkout.router
  (:require [reitit.frontend]
            [reitit.frontend.easy :as rfe]
            [reitit.coercion.malli :as rcm]
            [re-frame.core :as rf]))

(rf/reg-fx
 ::init
 (fn [routes]
   (println "init router")
   (rfe/start! (reitit.frontend/router routes
                                       {:data {:coercion rcm/coercion}})
               (fn [match]
                 (rf/dispatch [::set-route match])
                 (some-> match :data :on-navigate (rf/dispatch)))
               {:use-fragment false})))

(rf/reg-fx
 ::navigate
 (fn [route-name]
   (rfe/navigate route-name)))

(rf/reg-event-fx
 ::navigate
 (fn [_ [_ name]]
   {::navigate name}))

(rf/reg-event-fx
 ::init
 (fn [{:keys [db]} [_ routes]]
   {::init routes
    :db (assoc-in db [::db :routes] routes)}))

(rf/reg-event-fx
 ::set-route
 (fn [{:keys [db]} [_ match]]
   {:db (assoc-in db [::db :route] match)}))

(rf/reg-sub
 ::route
 (fn [db]
   (get-in db [::db :route])))

(rf/reg-sub
 ::current-view-component
 :<- [::route]
 (fn [route]
   (get-in route [:data :view])))

(comment
  (rf/dispatch [::navigate :stripe]))
